export default __webpack_public_path__ + "096a16a2304f0d14567d49061bd99c17.webp";